module.exports = __webpack_public_path__ + "img/testimonial-adam-c.3b9ccac1.png";